import { Row, Col } from 'src/componentes/grid';
import { matchesSearch, LookupField, createLookupModel } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import PeriodicidadeLookup from 'src/lookups/periodicidade';
import TratamentoLookup from 'src/lookups/tratamento-risco';
import FarolAvaliacaoRiscoLookup from 'src/lookups/FarolAvaliacaoRiscoLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';

/**
 * Seção de Avaliação
 */
const EvaluationSection = ({
  model,
  resources,
  intl,
  configuracao,
  searchQuery,
}) => {
  const fields = [
    {
      label: intl.formatMessage({ id: 'label.periodicidadeAvaliacao' }, { avaliacao: resources.avaliacao }),
      id: 'periodicidadeAvaliacao',
    },
    {
      label: intl.formatMessage({ id: 'labelStatusAvaliacao' }, { avaliacao: resources.avaliacao }),
      id: 'statusAvaliacoes',
    },
    configuracao?.utilizarTratamento && {
      label: intl.formatMessage({ id: 'tratamento' }),
      id: 'tratamentoRisco',
    },
  ].filter(Boolean);

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;
  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  return (
    <CollapsibleSection
      title={resources?.avaliacao || 'Avaliação'}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(
          fields.find((f) => f.id === 'periodicidadeAvaliacao')
        ) && (
          <Col md={12}>
            <LookupField
              Component={PeriodicidadeLookup}
              clearable
              highlight={matchesSearch(
                intl.formatMessage({ id: 'label.periodicidadeAvaliacao' }, { avaliacao: resources.avaliacao }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'label.periodicidadeAvaliacao' }, { avaliacao: resources.avaliacao }),
                model.getModel('periodicidadeAvaliacao')?.value,
                model.getModel('periodicidadeAvaliacao')?.requestChange,
                model.getModel('periodicidadeAvaliacao')?.errors
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'statusAvaliacoes')
        ) && (
          <Col md={12}>
            <LookupField
              Component={FarolAvaliacaoRiscoLookup}
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelStatusAvaliacao' }, { avaliacao: resources.avaliacao }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelStatusAvaliacao' }, { avaliacao: resources.avaliacao }),
                model.getModel('statusAvaliacoes')?.value,
                model.getModel('statusAvaliacoes')?.requestChange
              )}
            />
          </Col>
        )}

        {configuracao?.utilizarTratamento &&
          visibleFields.includes(
            fields.find((f) => f.id === 'tratamentoRisco')
          ) && (
            <Col md={12}>
              <LookupField
                Component={TratamentoLookup}
                clearable
                multi
                highlight={matchesSearch(
                  intl.formatMessage({ id: 'tratamento' }),
                  searchQuery
                )}
                model={createLookupModel(
                  intl.formatMessage({ id: 'tratamento' }),
                  model.getModel('tratamentoRisco')?.value,
                  model.getModel('tratamentoRisco')?.requestChange
                )}
              />
            </Col>
          )}
      </Row>
    </CollapsibleSection>
  );
};
export default EvaluationSection;